module.exports = __webpack_public_path__ + "media/images/client-25-6913f60e4e9132b841159d6f9c258532.png";